module.exports = __webpack_public_path__ + "static/media/thumbs_dsc_7544.8a80093c.jpg";